module.exports = __webpack_public_path__ + "static/media/GF-Hangman.09f5ee56.gif";